import { Pipe, PipeTransform } from '@angular/core';

import { Category } from '../../categories/shared';
import { Product } from './product.model';

@Pipe({
  name: 'productFilter'
})
export class ProductFilterPipe implements PipeTransform {
  transform(products: Array<Product>, name: string, sku: string, active: boolean, category: Category): any {
    if (products) {
      return products.filter((product: Product) => {
        let valid = true;

        if (
          (name) &&
          (product.name.toLowerCase().lastIndexOf(name.toLowerCase()) == -1)
        ) {
          valid = false;
        }

        if (
          (sku) &&
          (product.sku.toLowerCase().lastIndexOf(sku.toLowerCase()) == -1)
        ) {
          valid = false;
        }

        if ((active !== null) && (product.active !== active)) {
          if (typeof active !== "number") {
            valid = false;
          }
        }

        if (
          (category) &&
          (product.category) &&
          (product.category._id !== category._id)
        ) {
          valid = false;
        }

        return valid;
      });
    }

    return products;
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/product-filter.pipe.ts